export function mouseEventOk(event, mol) {
  if (event.atom && mol.atoms[event.idx] == null) {
    return false;
  }
  if (event.bond && mol.bonds[event.idx] == null) {
    return false;
  }
  return true;
}
